<template>
  <div v-if="material" class="text-danger small">
    <div>
      {{ $t('found_similar_material') }}:
      <span v-if="material.name">{{ $t('title') }}: {{ material.name }}</span>
      <span v-if="material.barcode">, {{ $t('barcode') }}: {{ material.barcode }}</span>
      <span v-if="material.artikul">, {{ $t('artikul') }}: {{ material.artikul }}</span>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    material: {
      type: Object,
      required: true
    }
  })
</script>
